import styled from "styled-components";
import Dialog from "@mui/material/Dialog";

import { breakpoints } from "@/styles/breakpoints";

export const StyledErrorDialog = styled(Dialog)`
    .dialog-paper {
        box-sizing: border-box;
        padding: 30px 25px 40px 25px;

        .errorIcon {
            text-align: center;

            svg {
                @media ${breakpoints.xs} {
                    height: 100%;
                }
            }

            img {
                width: 260px;
                @media ${breakpoints.sm} {
                    width: 180px;
                }
            }
        }

        .dialog-title-root {
            padding: 0;

            .errorTitle {
                margin-top: 15px;
                margin-bottom: 20px;
                font-size: var(--size-18);
                font-style: normal;
                font-weight: bold;
                line-height: 34px;
                color: var(--color-primary);
                text-align: center;
            }
        }

        .errorMessage {
            margin-bottom: 3rem;
            font-size: var(--size-16);
            font-style: normal;
            line-height: 22px;
            color: var(--color-grey-800);
            text-align: center;
        }

        .dialog-actions-root {
            padding: 0;
        }
    }
`;
